import React, { useState, useContext } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import { ThemeContext } from 'styled-components';
import { TableEmpty, CadastroClienteModal, Icon, ModalClose, ModalConfirmation } from '../../components';
import { icons, themes } from '../../assets';
import { Skeleton } from '..';
import Switch from "react-switch";
import { postEditStatus, postEditClient } from '../../services';
import * as s from './styled-customers-table';
import { notifyError } from '../../utils';

const TableClientes = ({
  loading,
  data,
  buscaClientes
}) => {
  const [closeConfirmation, setCloseConfirmation] = useState(false);
  const { title, colors } = useContext(ThemeContext);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [isModalEditVisibleConcluido, setIsModalEditVisibleConcluido] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [clienteEditado, setClienteEditado] = useState()
  const [clienteSelecionado, setClienteSelecionado] = useState({
    sigla: "",
    name: "",
    cnpj: "",
    email: "",
    endereco: "",
    estado: "",
  })

  createTheme('darkmode', {
    background: {
      default: colors.card,
    },
    divider: {
      default: colors.disabled,
    },
    highlightOnHover: {
      default: colors.lightgrey,
    },
  });

  const columns = [
    {
      name: 'Empresa',
      selector: '',
      sortable: false,
      minWidth: '185px',
      cell: ({ name }) => (
        <s.Label color={colors.darkerblue}>
          {name}
        </s.Label>
      ),
    },
    {
      name: 'Email de Contato',
      selector: '',
      sortable: false,
      minWidth: '195px',
      cell: ({ email }) => (
        <s.Label color={themes.label}>
          {email}
        </s.Label>
      ),
    },
    {
      name: 'Status',
      selector: '',
      sortable: false,
      maxWidth: '8%',
      cell: ({ status }) => (
        <s.Label color={status ? themes.statusN : themes.darkerblue}>
          {status ? 'Ativo' : 'Inativo'}
        </s.Label>
      ),
    },
    {
      name: 'Ativação',
      selector: '',
      sortable: false,
      maxWidth: '10%',
      cell: ({ status, id }) => <Switch
        onColor={themes.statusN}
        offColor={themes.darkerblue}
        onHandleColor={themes.white}
        offHandleColor={themes.white}
        checkedIcon={false}
        uncheckedIcon={false}
        checked={status}
        onChange={async () => {
          await postEditStatus(id, !status);
          await buscaClientes();
        }} />,
    },
    {
      name: 'Editar',
      selector: '',
      sortable: false,
      maxWidth: '10%',
      cell: (row) =>
        <s.IconButton
          type="button"
          title="Editar cliente"
          onClick={() => {
            setIsModalEditVisible(true)
            setClienteSelecionado(row)
          }}
        >
          <Icon name="pencil" size={18} />
        </s.IconButton>,
        style: {
          display: "flex",
          justifyContent: "center"
        }
    },
  ];

  const editarCliente = (values) => {
    postEditClient(clienteSelecionado.id,{
      sigla: values.sigla,
      name: values.name,
      email: values.email,
      endereco: values.endereco,
      estado: values.estado
    })
      .then(() => {
        setIsModalEditVisible(false);
        setConfirmationModal(false);
        setIsModalEditVisibleConcluido(true);
      })
      .catch(error => {
        if (error && error.message) notifyError(error.message);
        else notifyError('Ocorreu um erro ao salvar o cliente');
        
        setConfirmationModal(false);
      });
  }

  return (
    <>
      {confirmationModal ? (
        <ModalConfirmation 
        onClose={() => { editarCliente(clienteEditado); }}
        onCloseConfirmation={setConfirmationModal}
        />
      ) : null}
      {isModalEditVisibleConcluido ? 
        <CadastroClienteModal
          onClose={() => {
            setIsModalEditVisibleConcluido(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
          setTelaConcluido={setIsModalEditVisibleConcluido}
          formikInitialValues={clienteSelecionado}
          telaConcluido={isModalEditVisibleConcluido}
          title="Editar Cliente"
          sucesso="Cliente editado com sucesso!"
          iconFinal={icons.ClientesIconEdit}
        />
      : null}
      {isModalEditVisible ?
        <CadastroClienteModal
          onClose={() => {
            setIsModalEditVisible(false); buscaClientes();
          }}
          onCloseConfirmation={setCloseConfirmation}
          submit={setClienteEditado}
          setConfirmationModal={setConfirmationModal}
          setTelaConcluido={setIsModalEditVisibleConcluido}
          telaConcluido={isModalEditVisibleConcluido}
          formikInitialValues={clienteSelecionado}
          title="Editar Cliente"
          dadosAbaixo="Modifique os dados abaixo:"
          msgButton="Confirme suas modificações"
          labelButton="SALVAR"
          sucesso="Cliente editado com sucesso!"
          estadoValue={clienteSelecionado.estado}
          iconFinal={icons.ClientesIconEdit}
        /> : null}
        {closeConfirmation ?
          <ModalClose 
            onClose={() => {setIsModalEditVisible(false); buscaClientes(); setCloseConfirmation(false)}}
            onCloseConfirmation={setCloseConfirmation}
          /> : null}
      <DataTable
        theme={title === 'light' ? 'default' : 'darkmode'}
        noHeader
        columns={columns}
        data={data}
        highlightOnHover
        fixedHeader
        responsive
        pagination={false}
        persistTableHead
        progressPending={loading}
        noDataComponent={<TableEmpty titulo="Nenhum cliente foi encontrado" subtitulo="Cadastre clientes para começar" icon={icons.ClientesIconGray} />}
        ignoreRowClick
        customStyles={{
          table: {
            style: {
              flex: 1,
              marginTop: "10px",
              marginBottom: "5px",
              height: '100%',
              paddingBottom: "1.0vh",
            },
          },
          headRow: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          rows: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          cells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
          headCells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        }}
        progressComponent={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              padding: 16,
              gap: 8,
            }}
          >
            <Skeleton count={6} height="32px" />
          </div>
        }
      />
    </>
  );
};

export default TableClientes;
